<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.saleSettlements'), $t('text.list')]">
        <el-button type="success" size="mini" @click="add"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.title"
            :placeholder="$t('settlement.title')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="title"
          :title="$t('settlement.title')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)">{{ row.title }}</span>
            <div class="font10 blue" @click="showDetail(row)">
              {{ $t("text.settlementLineItem") }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="settleAmount"
          :title="$t('settlement.amount')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.settleAmount | currency }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="settlerName"
          :title="$t('settlement.settlerName')"
          min-width="100"
        />
        <vxe-table-column
          field="settle"
          :title="$t('settlement.settle')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.settle) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="voucher"
          :title="$t('payment.voucher')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <thumbnail-text :srcs="row.voucher" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="createdAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="110">
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="!row.settle"
              type="text"
              size="mini"
              @click="edit(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-button
              v-if="!row.settle"
              type="text"
              size="mini"
              @click="deleteRow(row)"
              >{{ $t("text.delete") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <!-- 编辑 -->
    <el-dialog
      :title="$t('rules.edit', [$t('settlement.title')])"
      :visible.sync="editDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="60px">
        <el-form-item
          :label="$t('settlement.title')"
          :prop="'title'"
          :rules="[
            { required: true, validator: validateTitleEdit, trigger: 'blur' },
          ]"
        >
          <el-input size="small" v-model.trim="editObj.title" />
        </el-form-item>
        <el-form-item :prop="'settle'" :label="$t('settlement.settle')">
          <el-checkbox v-model="editObj.settle"></el-checkbox>
        </el-form-item>
        <el-form-item :prop="'voucher'" :label="$t('payment.voucher')">
          <dropzone v-model="editObj.voucher" multiple />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :visible.sync="addDF"
      :close-on-click-modal="false"
      width="55%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <el-row>
          <el-col :span="10">
            <el-form-item
              :label="$t('settlement.title')"
              :prop="'title'"
              :rules="[
                { required: true, validator: validateTitle, trigger: 'blur' },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.title" />
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item :label="$t('payment.receiveAt')" required>
              <date-range
                v-model="addObj"
                type="datetime"
                field="paidAt"
                :start-placeholder="$t('text.startAt')"
                :end-placeholder="$t('text.endAt')"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('salesTarget.userName')">
              <el-checkbox-group v-model="addObj.ownerIds" class="pt8">
                <el-checkbox
                  size="small"
                  v-for="(user, index) of users"
                  :key="index"
                  :label="user.id"
                  >{{ user.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('menu.shops')">
              <el-checkbox-group v-model="addObj.shopIds" class="pt8">
                <el-checkbox
                  size="small"
                  v-for="(shop, index) of shops"
                  :key="index"
                  :label="shop.id"
                  >{{ shop.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('text.workflowState')">
              <el-checkbox-group v-model="addObj.workflowStates" class="pt8">
                <el-checkbox
                  size="small"
                  v-for="(state, index) of states"
                  :key="index"
                  :label="state"
                  >{{ $t("orderStates." + state) }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('text.lineItem')"
      v-if="lineItemDF"
      :visible.sync="lineItemDF"
      :close-on-click-modal="false"
      width="80%"
    >
      <line-item
        :id="currentRowId"
        @close="lineItemClose"
        @updateData="lineItemCloseUpdate"
      />
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils";
import ThumbnailText from "@/components/ThumbnailText";
import Dropzone from "@/components/Dropzone";
import DateRange from "@/components/DateRange";

import Show from "./show";
import SaleSettlement from "@/api/saleSettlement.js";
import Order from "@/api/order.js";
import User from "@/api/user.js";
import Shop from "@/api/shop.js";
import Payment from "@/api/payment.js";
import LineItem from "./lineItem";
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Show,
    ThumbnailText,
    Dropzone,
    LineItem,
  },
  data() {
    var validateTitleEdit = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      SaleSettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.row.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    var validateTitle = (rule, value, callback) => {
      const self = this;
      if (value == null || value === "") {
        callback(
          new Error(self.$t("rules.required", [self.$t("settlement.title")]))
        );
        return;
      }
      SaleSettlement.findByTitle({ title: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("settlement.title")]))
          );
          return;
        } else {
          callback();
        }
      });
    };
    return {
      narrows: [
        [
          {
            label: this.$t("manufacture.salaryInfo"),
            items: [
              {
                label: this.$t("salaryInfos.yes"),
                key: "yes",
                condition: { settle: "yes" },
              },
              {
                label: this.$t("salaryInfos.no"),
                key: "no",
                condition: { settle: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: null,
      searchForm: {
        title: null,
      },
      sorter: {
        sortBy: "saleSettlements_id",
        sortIndicator: "desc",
      },

      payments: [],
      //
      currentRowIdx: null,
      currentRowId: null,
      showDF: false,
      row: null,
      // 编辑
      validateTitleEdit: validateTitleEdit,
      editDF: false,
      editObj: {
        title: null,
        settle: null,
        voucher: null,
      },
      editDoing: false,
      // 新增
      validateTitle: validateTitle,
      addDF: false,
      users: [],
      shops: [],
      states: Order.states_all,
      addObj: {
        title: null,
        workflowStates: [],
        ownerIds: [],
        shopIds: [],
        paidAtStartAt: null,
        paidAtEndAt: null,
      },
      addDoing: false,
      //
      lineItemDF: false,
    };
  },

  created() {
    const self = this;
  },
  methods: {
    //
    showDetail(row) {
      this.currentRowId = row.id;
      this.lineItemDF = true;
    },
    lineItemClose() {
      this.lineItemDF = false;
      this.loadData();
    },
    lineItemCloseUpdate() {
      this.loadData();
    },
    //
    add() {
      const self = this;
      self.addObj.title = Util.serialNoSimple();
      self.addObj.ownerIds = [];
      self.addObj.shopIds = [];
      self.addObj.workflowStates = [];
      self.addObj.paidAtStartAt = null;
      self.addObj.paidAtEndAt = null;
      axios.all([User.findByTenantId(), Shop.findByTenantId()]).then(
        axios.spread(function (users, shops) {
          if (users.status == 200) {
            const allUsers = users.data.filter((u) => u.authorize == true);
            if (self.Permit.currentUser().admin === true) {
              self.users = allUsers;
            } else {
              self.users = allUsers.filter((u) =>
                JSON.parse(self.Permit.currentUser().manageUsers).includes(u.id)
              );
            }
          } else {
            self.sysError();
          }
          if (shops.status == 200) {
            self.shops = shops.data;
            self.addDF = true;
          } else {
            self.sysError();
          }
        })
      );
    },
    addSubmit() {
      const self = this;
      if (self.addObj.paidAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("payment.receiveAt")]),
          type: "warning",
        });
        return;
      }
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.addDoing = true;
          Payment.unSaleSettle(Util.deleteObjValueIsNull(self.addObj)).then(
            function (res) {
              if (res.status === 200) {
                self.addDoing = false;
                if (res.data.payments.length === 0) {
                  self.$message({
                    message: self.$t("text.noData"),
                    type: "warning",
                  });
                } else {
                  self.$router.push({
                    name: "fnReportsSaleSettlementsNew",
                    params: { title: self.addObj.title },
                    query: Util.deleteObjValueIsNull(self.addObj),
                  });
                  self.addDF = false;
                }
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        SaleSettlement.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.currentRowIdx = rowIndex;
      self.editObj.title = row.title;
      self.editObj.settle = row.settle;
      self.editObj.voucher = row.voucher;
      self.editDoing = false;
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          SaleSettlement.update(this.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.records[self.currentRowIdx].title = self.editObj.title;
              self.records[self.currentRowIdx].settle = self.editObj.settle;
              self.records[self.currentRowIdx].voucher = self.editObj.voucher;
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    //-----
    dataProvider(params) {
      return SaleSettlement.search(params);
    },
  },
};
</script>
